/**
 * Angular imports.
 */
import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

/**
 * Service imports.
 */
import { OnboardingService } from '../../../../dataservices/onboarding/onboarding.service';
import { MultiLangService } from '../../../../dataservices/master-service/multi-lang.service';
import { NewLanguageService } from '../../../../dataservices/new-language/new-language.service';

/**
 * Rxjs imports.
 */
import { takeUntil } from 'rxjs/operators';
import { Subscription, Subject } from 'rxjs';


/**
 * Ass Doc Req Card Component
 */
@Component({
  selector: 'app-ass-doc-req-card',
  templateUrl: './ass-doc-req-card.component.html',
  styleUrls: ['./ass-doc-req-card.component.scss']
})
export class AssDocReqCardComponent implements OnInit, OnChanges {
  private notifier$ = new Subject();
  @Input() listData;
  @Input() errObj;
  @Input() hasChanged;
  @Input() callingfrom;
  @Output() userInput = new EventEmitter();
  @Output() fileUpload = new EventEmitter();
  @Output() mrnFocus = new EventEmitter();
  public infomrn = false;
  public url: '';
  public uploadfilearray = [];
  public uploadcounter = 0;
  public uploadFile_api_in_process = false;
  public error_msg = '';
  public upload_data = { absolute_path: '', fileurl: '', status: 1, msg: '' };
  public inputData = {
    'identifier': '',
    'log_id': '',
    'value': '',
    'doc_url': ''
  };

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(
    private onboardingService: OnboardingService,
    public multiLangService: MultiLangService,
    public mls: NewLanguageService) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.inputData.identifier = this.listData.required_details.identifier;
    this.inputData.log_id = this.listData.log_id;
    this.inputData.value = this.listData.required_details.input_type.value;
    this.inputData.doc_url = this.listData.required_details.document.doc_url;
    this.upload_data.absolute_path = this.listData.required_details.document.doc_url;
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    setTimeout(() => {
      this.userInput.emit(this.inputData);
    }, 300);
  }

  /**
   * user doc Input
   */
  userdocInput(event): void {
    this.inputData.value = event.target.value;
    this.userInput.emit(this.inputData);
  }

  /**
   * onSelect File
   */
  onSelectFile(fileInput): void {
    this.uploadfilearray = [];
    this.uploadcounter = 0;
    const file = fileInput.target.files[0];
    this.url = fileInput.target.result;
    this.error_msg = '';
    const file_type = fileInput.target.files[0].type;
    if (file_type != 'image/jpeg' && file_type != 'image/jpg' && file_type != 'image/png') {
      this.error_msg = this.mls.languageText.association_verification_screen.key5;
      return;
    }
    const blob = fileInput.target.files[0];
    let BYTES_PER_CHUNK = 1000024; // **1MB chunk sizes.
    const SIZE = blob.size;
    if (SIZE > 1000024) {
      BYTES_PER_CHUNK = 1000024;
    } else if (SIZE > 100024) {
      BYTES_PER_CHUNK = 100024;
    } else if (SIZE > 10024) {
      BYTES_PER_CHUNK = 10024;
    } else {
      BYTES_PER_CHUNK = 1024;
    }


    const remaining_bites = SIZE % BYTES_PER_CHUNK;
    let start = 0;
    let end = BYTES_PER_CHUNK;
    const d = new Date();
    const n = d.getTime();
    let fileName;

    const count_x = Math.floor(SIZE / BYTES_PER_CHUNK);
    let x = 0;
    while (x < count_x) {
      const chunk = blob.slice(start, end);
      this.uploadfilearray[this.uploadcounter] = chunk;
      this.uploadcounter = this.uploadcounter + 1;
      start = end;
      end = start + BYTES_PER_CHUNK;
      x++;
    }
    if (remaining_bites > 0) {
      const chunk = blob.slice(start, end);
      this.uploadfilearray[this.uploadcounter] = chunk;
      this.uploadcounter = this.uploadcounter + 1;
      start = end;
      end = remaining_bites;
    }
    const num_chunks = this.uploadcounter; // total number of chunks
    this.uploadcounter = 0;
    fileName = n + file.name;
    fileName = fileName.replace(/ /g, '_');
    this.uploadFile_api_in_process = true;
    this.uploadFile(this.uploadfilearray[this.uploadcounter], fileName, num_chunks, this.uploadcounter + 1, file_type, '1');

    fileInput.target.value = '';
  }

  /**
   * upload File
   */
  uploadFile(blobFile, filename, num_chunks, num, file_type, product_type): void {
    if (this.uploadfilearray.length > this.uploadcounter) {
      this.onboardingService.newUploadInChunk(blobFile, filename, num_chunks, this.uploadcounter + 1, file_type, product_type).pipe(takeUntil(this.notifier$)).subscribe(data => {

        this.uploadcounter = this.uploadcounter + 1;
        if (this.uploadfilearray.length > this.uploadcounter) {
          this.uploadFile(this.uploadfilearray[this.uploadcounter], filename, num_chunks, this.uploadcounter, file_type, product_type);
        } else {
          this.error_msg = '';
          this.upload_data = data.data;
          if (this.upload_data.fileurl != undefined) {
            this.uploadFile_api_in_process = false;
            this.inputData.doc_url = this.upload_data.fileurl;
            this.userInput.emit(this.inputData);
          }
        }
      }, () => {
        this.uploadFile_api_in_process = false;
      });
    }
  }
  /**
   * remove College Id
   */
  removeCollegeId(): void {
    this.upload_data.absolute_path = '';
    this.upload_data.fileurl = '';
    this.inputData.doc_url = '';
    this.userInput.emit(this.inputData);
  }

}
